module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_GA-eab7bf8e14169ec50d39a80f4c45a00d.svg";